import React, {Component} from "react";
import SidebarComponent from "../../../../shared/sidebar/SidebarComponent";
import Links from "../../../../utilities/linksConfig/Links";
import {Col, Grid, Row} from "react-bootstrap";
import TopBreadcumb from "../../../../componentsTopsa/breadcrumbs/TopBreadcumb";
import SubHeader from "../../../../shared/sidebar/SubHeader";
import DefiniowanieZamawiajacegoForm from "./components/definiowanieZamawiajacego/DefiniowanieZamawiajacegoForm";
import DefiniowanieZamowieniaForm from "./components/definiowanieZamowienia/DefiniowanieZamowieniaForm";
import LSService from "../../../../utilities/localStorageService/LSService";


export default class DodajBiletJednorazowyContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            klientZLocalStorage: null,
            zamawiajacyKlient: null,     // moze byc jednorazowy oraz klient zwykly
        }
        this.onChangeKlient = this.onChangeKlient.bind(this)
        this.onChangeJednorazowyObject = this.onChangeJednorazowyObject.bind(this)
    }

    componentDidMount() {

        // przypadek 1 - klient jest nowo utworzony - LSService.pobierzInformacjeONowoUtworzonymKliencie()
        // przypadek 2 - przekierowanie z innego widoku - LSService.pobierzDaneKlientaDoDodaniaJedn()
        // w obu przypadkach przychodzi obiekt klienta, this.setState({klientZLocalStorage:object})


        this.setState({
            zamawiajacyKlient:
                {
                    idKl: 1, czyKlientJednorazowy: true, zamawiajacy: '', email: '', telefon: '',zamawiajacyNazwisko:'',zamawiajacyImie:''
                }
        })


        if(Boolean(LSService.pobierzInformacjeONowoUtworzonymKliencie())){
            let klient = LSService.pobierzInformacjeONowoUtworzonymKliencie()
            this.setState({klientZLocalStorage:klient})
            this.onChangeKlient(klient)
            LSService.usunNowoUtworzonegoKlienta()
        }
        if(Boolean(LSService.pobierzDaneKlientaDoDodaniaJedn())){
            let klient = LSService.pobierzDaneKlientaDoDodaniaJedn()
            this.setState({klientZLocalStorage:klient})
            this.onChangeKlient(klient)
            LSService.usunDaneKlientaDoDodaniaJedn()
        }


    }

    onChangeKlient(obj) {
        this.setState({
            zamawiajacyKlient:
                {
                    idKl: obj.idKl, czyKlientJednorazowy: false, zamawiajacy: obj.imieNazwisko, email: obj.email, telefon: obj.nrTel,zamawiajacyNazwisko:obj.nazwisko,zamawiajacyImie:obj.imie
                }
        })
    }

    onChangeJednorazowyObject(obj) {
        this.setState({zamawiajacyKlient: obj})
    }

    render() {
        return (
            <SidebarComponent links={Links.getKonfiguracjaLinks} currentLink={this.props.match.path} history={this.props.history}
                              collapsedLinks={this.props.collapsedLinks}
                              handleClickToogleSidebar={(module) => this.props.handleClickToogleSidebar(module)}>
                <Grid fluid={true} id={'ZarzadzanieBiletamiContainer'}>
                    <Row>
                        <Col sm={12}>
                            <div id="subheader">
                                <TopBreadcumb links={[
                                    {addressUrl: '/konfiguracja', text: 'Konfiguracja'},
                                    {addressUrl: '/konfiguracja/zarzadzanie-biletami', text: 'Zarządzanie biletami'},
                                    {addressUrl: '/konfiguracja/zarzadzanie-biletami/bilety-jednorazowe', text: 'Bilety jednorazowe'},
                                    {addressUrl: '/konfiguracja/zarzadzanie-biletami/bilety/dodaj-jednorazowy', text: 'Dodaj nowy'}
                                ]}/>
                                <SubHeader currentLink={this.props.match.path} obecnyKalendarz={this.props.obecnyKalendarz}
                                           history={this.props.history}/>
                            </div>
                        </Col>
                        <Col sm={12}>
                            <DefiniowanieZamawiajacegoForm
                                klientZLocalStorage={this.state.klientZLocalStorage}
                                handleChangeKlient={this.onChangeKlient}
                                handleJednorazowyObject={this.onChangeJednorazowyObject}
                            />
                        </Col>
                        <Col xs={12}>
                            <DefiniowanieZamowieniaForm
                                zamawiajacyKlient={this.state.zamawiajacyKlient}
                                history={this.props.history}
                            />
                        </Col>
                    </Row>
                </Grid>
            </SidebarComponent>
        )
    }

}


// WEBPACK FOOTER //
// ./src/modules/konfiguracja/biletyConfig/dodajBiletJednorazowy/DodajBiletJednorazowyContainer.js